import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './ServicesSession.css';

function ServicesSession() {
  const services = [
    { id: 1, title: "Full Logistics",content:"Tailored answers for your distinct and intricate logistics requirements..", image: './Pics/Services1.jpg', link: "/fulllogistic" },
    { id: 2, title: "Sea Freight",content:"Economical ocean freight forwarding by experienced shipping professionals.. ", image: './Pics/Services2.jpg', link: "/seafreight" },
    { id: 3, title: "Cargo",content:"The effectiveness of warehouse and logistics solutions.. ", image: './Pics/Services3.jpg', link: "/services/cargo" },
    { id: 4, title: "Road",content:"Enhance proficiency with high-caliber road freight solutions and a dynamic team.. ", image: './Pics/Services4.jpg', link: "/road" },
    { id: 5, title: "Air Freight",content:"Secured air freight options, managed with precision for a hassle-free experience..", image: './Pics/Services5.jpg', link: "/airfreight" },
  ];

  // Set the middle service as default
  const defaultService = services[Math.floor(services.length / 2)];
  const [activeImage, setActiveImage] = useState(defaultService.image);
  const [activeServiceId, setActiveServiceId] = useState(defaultService.id);
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Check if the screen is mobile size
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 992);
    };
    
    // Initial check
    checkScreenSize();
    
    // Add event listener for window resize
    window.addEventListener('resize', checkScreenSize);
    
    // Cleanup
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // Preload all images before showing any
  useEffect(() => {
    let loadedCount = 0;
    const totalImages = services.length;
    
    const imagePromises = services.map(service => {
      return new Promise((resolve) => {
        const img = new Image();
        img.src = service.image;
        img.onload = () => resolve();
      });
    });

    Promise.all(imagePromises).then(() => {
      setImagesLoaded(true);
    });
  }, []);

  const handleServiceInteraction = (service) => {
    setActiveImage(service.image);
    setActiveServiceId(service.id);
  };

  if (!imagesLoaded) {
    return (
      <div className="services-session">
        <div className="services-header">
          <h2 className="services-title">OUR SERVICES</h2>
          <p className="services-description">Loading services...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="services-session">
      <div className="services-header">
        <h2 className="services-title">OUR SERVICES</h2>
        <p className="services-description">
          Discover a world of seamless shipping solutions with our premier agency. 
          With an extensive global network and a team of experts, we ensure efficient 
          and secure deliveries to any destination. Our personalized approach tailors 
          each shipment to your unique needs, guaranteeing the utmost care and attention to your cargo.
        </p>
        <Link to="/services"  className="view-all-btn">View All</Link>
      </div>

      {isMobile ? (
        // Mobile layout - vertical services
        <div className="services-container-mobile">
          {services.map((service, index) => (
            <React.Fragment key={service.id}>
              <div 
                className={`service-box-mobile ${service.id === activeServiceId ? 'active' : ''}`}
                style={{ backgroundImage: `url(${service.image})` }}
                onClick={() => handleServiceInteraction(service)}
              >
                {service.id === activeServiceId && (
                  <div className="service-content-mobile">
                    <p className='services-tital-box'>{service.title}</p>
                    <p>{service.content}</p>
                    <Link to={service.link} className="read-more-link">Read More</Link>
                  </div>
                )}
              </div>
              {index < services.length - 1 && <div className="divider-mobile"></div>}
            </React.Fragment>
          ))}
        </div>
      ) : (
        // Desktop layout - horizontal services
        <div 
          className="services-container" 
          style={{ backgroundImage: `url(${activeImage})` }}
        >
          {services.map((service, index) => (
            <React.Fragment key={service.id}>
              <div 
                className={`service-box ${service.id === activeServiceId ? 'active' : ''}`}
                onMouseEnter={() => handleServiceInteraction(service)}
              >
                {service.id === activeServiceId && (
                  <div className="service-content">
                   <p className='services-tital-box'>{service.title}</p>
                    <p>{service.content}</p>
                    <Link to={service.link} className="read-more-link">Read More</Link>
                  </div>
                )}
              </div>
              {index < services.length - 1 && <div className="divider"></div>}
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
}

export default ServicesSession;
